import { render } from "./NotReady.vue?vue&type=template&id=f32bcd6c"
import script from "./NotReady.vue?vue&type=script&lang=js"
export * from "./NotReady.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__